import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import LoginView from './views/LoginView.vue';
import LogoutView from './views/LogoutView.vue';
import UploadView from './views/UploadView.vue';
import UserService from './services/UserService';
import GlobalService from './services/GlobalService';
import FileListView from "./views/FileListView.vue";
import SearchView from './views/SearchView.vue';
import PDFView from "./views/PDFView.vue";
import FileView from "./views/FileView.vue";
import TagsView from "./views/TagsView.vue";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: FileListView,
      meta: { requiresAuth: true, clear: true }
      // redirect: { name: 'documents' },
    },
    {
      path: '/documents',
      name: 'documents',
      component: FileListView,
      meta: { requiresAuth: true, clear: true }
    },
    {
      path: '/documents/starred',
      name: 'documents_starred',
      component: FileListView,
      meta: { requiresAuth: true, clear: true }
    },
    {
      path: '/document/:id',
      name: 'document',
      component: FileView,
      meta: { requiresAuth: true }
    },
    {
      path: '/search',
      name: 'search',
      component: SearchView,
      meta: { requiresAuth: true }
    },
    {
      path: '/tags',
      name: 'tags',
      component: TagsView,
      meta: { requiresAuth: true }
    },
    {
      path: '/upload',
      name: 'upload',
      component: UploadView,
      meta: { requiresAuth: true }
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView
    },
    {
      path: '/logout',
      name: 'logout',
      component: LogoutView
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

const userService = new UserService();
const globalService = new GlobalService();


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!userService.getSelf()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {

      if (to.meta.clear) {
        next();
      } else {
        next();
      }
    }
  } else {
    next();
  }
});

export default router;
